import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AddIcon, IconButton, BannerWrapper, Typography, SimpleImage } from "@parkschannel/ui";
import Link from "next/link";
export const BeLikeUserBanner = (param)=>{
    let { userName  } = param;
    return /*#__PURE__*/ _jsxs(BannerWrapper, {
        className: "bg-neutral-100",
        icon: /*#__PURE__*/ _jsx("div", {
            className: "relative w-full h-[200px]",
            children: /*#__PURE__*/ _jsx(SimpleImage, {
                src: "/media/illustrations/GrandCanyon.webp",
                alt: "Grand canyon",
                fill: true,
                className: "object-contain"
            })
        }),
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "h4",
                className: "text-neutral-900 !text-2xl lg:!text-3xl ",
                children: [
                    "Be like ",
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-primary-500",
                        children: userName
                    }),
                    " and share your travel experiences"
                ]
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "/videos/new",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    icon: /*#__PURE__*/ _jsx(AddIcon, {}),
                    position: "left",
                    className: "w-full flex justify-center md:w-fit md:h-[48px]",
                    children: "Submit a video"
                })
            })
        ]
    });
};
